<template>
  <div class="instruments">
    <topSection :symbol="currentSymbol"></topSection>
    <tabs :symbol="currentSymbol"></tabs>
    <div class="uk_not_available_strip" v-show="shouldBannerDisplayed">
      <div class="container">{{ t("Not_available_retail") }}</div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import tabs from "./tabs";
import TopSection from "@/views/plus/instruments/topSection";

export default {
  name: "Instruments",
  components: { TopSection, tabs },
  data() {
    return {
      userCountry: ""
    };
  },
  created() {
    this.completeSocketInitialization([this.currentSymbol]);
    this.getUserCountry();
  },
  mounted() {
    this.hideComponentMountLoader();
  },
  computed: {
    ...mapState(["symbolsData"]),
    ...mapGetters(["t", "baseNewApiUrl"]),
    currentSymbol: function() {
      return this.$route.params.symbol;
    },
    shouldBannerDisplayed: function() {
      const stripSymbolArr = [
        "BTCUSD",
        "BTCEUR",
        "DASHUSD",
        "DASHEUR",
        "ETHBTC",
        "ETHEUR",
        "ETHUSD",
        "LTCBTC",
        "LTCEUR",
        "LTCUSD",
        "XRPEUR",
        "XRPUSD",
        "XMREUR",
        "XMRUSD"
      ];
      if (
        this.userCountry == "GB" &&
        stripSymbolArr.includes(this.currentSymbol)
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    ...mapMutations(["hideComponentMountLoader"]),
    ...mapActions(["getInfoFromWebsite"]),
    ...mapActions('symbolsSocket',['completeSocketInitialization']),
    async getUserCountry() {
		let serviceUrl = "https://geoip.multiforwarder.click/";
		this.userCountry = (await (await fetch(serviceUrl)).json()).country;
    }
  }
};
</script>

<style lang="scss" scoped>
/* uk_not_available_strip */
.uk_not_available_strip {
  display: block;
  height: 73px;
  background: #ebf3f9;
}
.uk_not_available_strip .container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
@media screen and (max-width: 991px) {
  .uk_not_available_strip {
    height: 56px;
  }
  .uk_not_available_strip .container {
    justify-content: flex-start;
  }
}
/* /uk_not_available_strip */
</style>
